import { DOGMA_SOURCES as D } from "./dogmaSources";
import { scriptureLink } from "./scripture";

export const APOLOGETICS_SOURCES = {
  ...D,
  justin: "https://www.newadvent.org/fathers/01287.htm",
  eusebiusFamily: "https://www.newadvent.org/fathers/250103.htm",
  augustine: "https://www.newadvent.org/fathers/1503.htm",
  ambrose: "https://www.newadvent.org/fathers/34072.htm",
  damasceneMother: "https://www.newadvent.org/fathers/33043.htm",
  aquinasHonour: "https://www.newadvent.org/summa/4025.htm#article5",
  revelation: "https://www.vatican.va/archive/ENG0015/__PH.HTM",
  deiVerbum: "https://www.vatican.va/archive/hist_councils/ii_vatican_council/documents/vat-ii_const_19651118_dei-verbum_en.html",
  marialis: "https://www.vatican.va/content/paul-vi/en/apost_exhortations/documents/hf_p-vi_exh_19740202_marialis-cultus.html",
  rosarium: "https://www.vatican.va/content/john-paul-ii/en/apost_letters/2002/documents/hf_jp-ii_apl_20021016_rosarium-virginis-mariae.html",
  materPopuli: "https://www.vatican.va/roman_curia/congregations/cfaith/documents/rc_ddf_doc_20251104_mater-populi-fidelis_en.html",
};

export const source = (label, key) => ({ label, url: APOLOGETICS_SOURCES[key] });
export const scriptureSource = (ref) => {
  return { label: `${ref} · RSV-CE`, url: scriptureLink(ref) };
};